import { useGetErrorLogData } from "../queries/useGetErrorLogData"
import { CSTDateFormatterWithTime_12_hr } from "../utils/DateFormatter";


export const useErrorLogData = ({body, config}) => {
    const {data, isFetching, isError, error,refetch} = useGetErrorLogData({body, config});
    //console.log("data is bvkjhgljh", data);
    const {  file_errors_1: file_errors = [], file_errors_2: report_errors = [], system_errors = [] } = data || {};
    if(file_errors !== undefined && file_errors.length !== 0){
        file_errors['Date'] = CSTDateFormatterWithTime_12_hr(file_errors['Date'])
    }
    if(report_errors !== undefined && report_errors.length !== 0){
        var i = 0, len = report_errors.length;
        while(i<len){
            report_errors[i]['Timestamp'] = CSTDateFormatterWithTime_12_hr(report_errors[i]['Timestamp'])
            i++;
        }
    }
    if(system_errors !== undefined && system_errors.length !== 0){
        var i = 0, len = system_errors.length;
        while(i<len){
            system_errors[i]['TriggerTime'] = CSTDateFormatterWithTime_12_hr(system_errors[i]['TriggerTime'])
            i++;
        }
    }
    return { file_errors, report_errors,  system_errors , isFetching , isError, error, refetch};
}